import { useTranslation } from 'react-i18next';

import {
  IPatientsSyncStatusFilter,
  usePatientsSyncStatusFilters,
  useUpdatePatientsSyncStatusFilter,
} from '../../../../../../../features/patients';
import { Filter, IFilterProps } from '../../../../../filter';

export const SyncStatusFilter = () => {
  const { t } = useTranslation();
  const updateSyncStatusFilter = useUpdatePatientsSyncStatusFilter();
  const filters = usePatientsSyncStatusFilters();

  const buttonProps: IFilterProps['button'] = {
    text: t('patients.filter.syncState'),
    filters,
    getText: (keys: string[]) => {
      if (keys.length > 1) {
        return t('patients.filter.active', { length: keys.length });
      }

      return t(`common.syncState.option.${keys[0]}`);
    },
  };

  const popoverProps: IFilterProps['popover'] = {
    clearText: t('patients.filter.clear'),
    filters,
    getFilterText: (key) => t(`common.syncState.option.${key}`),
    onChange: (filters) => updateSyncStatusFilter(filters as IPatientsSyncStatusFilter),
    onClear: updateSyncStatusFilter,
  };

  return <Filter button={buttonProps} popover={popoverProps} />;
};
